module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-9-3189cc5329690d24413f988ab0c6ca43.png";